module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"components":{"social_events":{"empty_state":{"to_investment_profile":"Investmentprofil anpassen","to_notification_settings":"Mitteilungseinstellungen"}}}}}}')
  delete Component.options._Ctor
}
